export const comments_5031907 = {"data":{"data":[],"links":{}}}